export const PROGRAMS = ['Master', 'Transactional'] as const;

export type ReconCheck = {
  label: string;
  statusKey: string;
  leftKey: string;
  rightKey: string;
};

export const TRANSACTIONAL_RECON_CHECKS: ReconCheck[] = [
  {
    label: 'PEPIRIS vs EDF',
    statusKey: 'pepiris_vs_edf',
    leftKey: 'pepiris_count',
    rightKey: 'edf_count',
  },
  {
    label: 'EDF vs CC',
    statusKey: 'edf_vs_cc',
    leftKey: 'edf_count',
    rightKey: 'silver_inspections',
  },
  {
    label: 'Scenes: Silver vs Gold',
    statusKey: 'silver_total_scenes_available_vs_gold_fact_total_scenes_available',
    leftKey: 'silver_total_scenes_available',
    rightKey: 'gold_fact_total_scenes_available',
  },
  {
    label: 'Customers: Silver vs Gold',
    statusKey: 'silver_total_customers_available_vs_gold_fact_total_customers_available',
    leftKey: 'silver_total_customers_available',
    rightKey: 'gold_fact_total_customers_available',
  },
  {
    label: 'PEPSELL \u2192 Gold',
    statusKey: 'gold_pepsell_records_sent_vs_pepsell_count',
    leftKey: 'gold_pepsell_records_sent',
    rightKey: 'pepsell_count',
  },
  {
    label: 'Fact Total vs KPIs',
    statusKey: 'gold_fact_total_customers_available_vs_gold_kpis_total_customers_available',
    leftKey: 'gold_fact_total_customers_available',
    rightKey: 'gold_kpis_total_customers_available',
  },
  {
    label: 'Gold PEPSELL A vs B',
    statusKey: 'gold_pepsell_expected_records_vs_gold_pepsell_records_sent',
    leftKey: 'gold_pepsell_expected_records',
    rightKey: 'gold_pepsell_records_sent',
  },
];

export const MASTER_RECON_CHECKS: ReconCheck[] = [
  {
    label: 'PEPSELL vs EDF',
    statusKey: 'pepsell_vs_edf',
    leftKey: 'pepsell',
    rightKey: 'edf',
  },
  {
    label: 'EDF vs PEPIRIS',
    statusKey: 'edf_vs_pepiris',
    leftKey: 'edf',
    rightKey: 'pepiris',
  },
  {
    label: 'EDF vs CC',
    statusKey: 'edf_vs_cc',
    leftKey: 'edf',
    rightKey: 'cc',
  },
];

export const EXCEL_COLUMNS = [
  { key: 'run_date', label: 'DATE', aliases: ['run_date', 'date'] },
  { key: 'pepiris_count', label: 'PEPIRIS COUNT', aliases: ['pepiris_count', 'pepiris count'] },
  { key: 'edf_count', label: 'EDF COUNT', aliases: ['edf_count', 'edf count'] },
  { key: 'silver_inspections', label: 'SILVER INSPECTIONS', aliases: ['silver_inspections'] },
  { key: 'silver_inspections_with_visit', label: 'SILVER INSPECTIONS WITH VISIT', aliases: ['silver_inspections_with_visit'] },
  { key: 'silver_checkins_without_visit', label: 'SILVER CHECKINS WITHOUT VISIT', aliases: ['silver_checkins_without_visit'] },
  { key: 'silver_total_scenes_available', label: 'SILVER TOTAL SCENES AVAILABLE', aliases: ['silver_total_scenes_available'] },
  { key: 'gold_fact_total_scenes_available', label: 'GOLD FACT TOTAL SCENES AVAILABLE', aliases: ['gold_fact_total_scenes_available', 'gold_fact_total_scenes_availble'] },
  { key: 'silver_total_customers_available', label: 'SILVER TOTAL CUSTOMERS AVAILABLE', aliases: ['silver_total_customers_available'] },
  { key: 'gold_fact_total_customers_available', label: 'GOLD FACT TOTAL CUSTOMERS AVAILABLE', aliases: ['gold_fact_total_customers_available'] },
  { key: 'gold_kpis_total_customers_available', label: 'GOLD KPIS TOTAL CUSTOMERS AVAILABLE', aliases: ['gold_kpis_total_customers_available'] },
  { key: 'gold_pepsell_expected_records', label: 'GOLD PEPSELL EXPECTED RECORDS', aliases: ['gold_pepsell_expected_records'] },
  { key: 'gold_pepsell_records_sent', label: 'GOLD PEPSELL RECORDS SENT', aliases: ['gold_pepsell_records_sent'] },
  { key: 'pepsell_count', label: 'PEPSELL COUNT', aliases: ['pepsell_count', 'pepsell count'] },
  { key: 'pepiris_vs_edf', label: 'PEPIRIS VS EDF', aliases: ['pepiris_vs_edf', 'pepiris vs edf'] },
  { key: 'edf_vs_cc', label: 'EDF VS CC', aliases: ['edf_vs_cc', 'edf vs cc'] },
  { key: 'gold_pepsell_record_sent_vs_pepsell_count', label: 'GOLD PEPSELL RECORDS SENT VS PEPSELL COUNT', aliases: ['gold_pepsell_records_sent_vs_pepsell_count', 'gold pepsell records sent vs pepsell count'] },
  { key: 'silver_total_scenes_available_vs_gold_fact_total_scenes_available', label: 'SILVER TOTAL SCENES AVAILABLE VS GOLD FACT TOTAL SCENES AVAILABLE', aliases: ['silver_total_scenes_available_vs_gold_fact_total_scenes_available', 'silver_total_scenes_available_vs_gold_fact_total_scenes_availbale'] },
  { key: 'silver_total_customers_available_vs_gold_fact_total_customers_available', label: 'SILVER TOTAL CUSTOMERS AVAILABLE VS GOLD FACT TOTAL CUSTOMERS AVAILABLE', aliases: ['silver_total_customers_available_vs_gold_fact_total_customers_available'] },
  { key: 'gold_fact_total_customers_available_vs_gold_kpis_total_customers_available', label: 'GOLD FACT TOTAL CUSTOMERS AVAILABLE VS GOLD KPIS TOTAL CUSTOMERS AVAILABLE', aliases: ['gold_fact_total_customers_available_vs_gold_kpis_total_customers_available'] },
  { key: 'gold_pepsell_expected_records_vs_gold_pepsell_records_sent', label: 'GOLD PEPSELL EXPECTED RECORDS VS GOLD PEPSELL RECORDS SENT', aliases: ['gold_pepsell_expected_records_vs_gold_pepsell_records_sent'] },
] as const;

export const MASTER_COLUMNS = [
  { key: 'run_date', label: 'DATE', aliases: ['run_date', 'date'] },
  { key: 'description', label: 'DESCRIPTION', aliases: ['description'] },
  { key: 'pepsell', label: 'PEPSELL', aliases: ['pepsell', 'pep_sell'] },
  { key: 'edf', label: 'EDF', aliases: ['edf'] },
  { key: 'pepiris', label: 'PEPIRIS', aliases: ['pepiris', 'pep_iris'] },
  { key: 'pepsell_vs_edf', label: 'PEPSELL VS EDF', aliases: ['pepsell_vs_edf', 'pep_sell_vs_edf'] },
  { key: 'edf_vs_pepiris', label: 'EDF VS PEPIRIS', aliases: ['edf_vs_pepiris', 'edf_vs_pep_iris'] },
] as const;